/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_No_Valid_TermsInputs */



/**
* | output |
* | --- |
* | "No valid terms found in CSV" |
*
* @param {Knp_Terms_No_Valid_TermsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_no_valid_terms = /** @type {((inputs?: Knp_Terms_No_Valid_TermsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_No_Valid_TermsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun terme valide trouvé dans le CSV")
	if (locale === "de") return /** @type {LocalizedString} */ ("In der CSV-Datei wurden keine gültigen Begriffe gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun termine valido trovato nel CSV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В CSV-файле не найдено допустимых терминов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron términos válidos en CSV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("CSV 文件中未找到有效术语。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CSV に有効な用語が見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CSV में कोई मान्य शब्द नहीं मिले")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum termo válido encontrado no arquivo CSV.")
	return /** @type {LocalizedString} */ ("No valid terms found in CSV")
});